module.exports = __webpack_public_path__ + "wedding_classic-damask_1.jpg";